import React, { useEffect, useState } from "react";

const About = () => {
  const [marginLeft, setMarginLeft] = useState("-95px");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setMarginLeft("-95px");
      } else {
        setMarginLeft("0px");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className="px-8 lg:px-32 xl:px-52 mt-20">
      <p className="font-bold text-black text-3xl pt-6">About</p>
      <div className="container mx-auto px-2 py-8 text-justify">
        <div className="md:text-[17px] text-black">
          <div className="flex flex-col mx-auto text-black">
            <div>
              <p className="text-sm sm:text-base mb-4 text-justify">
                Introducing the <b>Women's Home Workout App Home Fit Pro</b>,
                your ultimate companion for achieving your fitness goals
                conveniently from the comfort of your home. Home Fit Pro is
                tailored exclusively for women embarking on a journey to enhance
                their well-being, be it Weight Loss, maintaining, or gaining
                strength.
              </p>
              <p className="text-sm sm:text-base mb-4 text-justify">
                Say farewell to expensive gym memberships and time-consuming
                commutes. Our app, crafted by industry experts, caters to the
                dynamic lifestyles of women on the go. The best part? It's FREE!
                With a repertoire of over 150 customized workout programs,
                choose the one that aligns with your fitness level, whether
                you're a beginner, intermediate, or advanced.
              </p>
              <p className="text-sm sm:text-base mb-4 text-justify">
                You can exercise anytime, anywhere, with easy-to-follow and
                highly effective routines that require no special equipment. Our
                Home Workout for Women emphasizes convenience and effectiveness,
                now enhanced with additional features.
              </p>
              <p className="text-sm sm:text-base mb-4 text-justify">
                Keep track of your progress comprehensively with our weight
                tracker, visual logs, and now, Health Data features including
                Calories Burnt, Steps Count, and Heart Rates. Monitor your body
                transformation journey seamlessly within the app.
              </p>
              <p className="text-sm sm:text-base mb-4 text-justify">
                Enhance your fitness routine with our Reminders feature. Stay on
                top of your hydration goals with the Water Reminder, ensure you
                never miss a workout session with the Workout Reminder, and stay
                consistent with your medications using the Medicine Reminder.
              </p>
              <p className="text-sm sm:text-base mb-4 text-justify">
                Share your achievements with friends to inspire and motivate
                each other. Post your progress images and workout selfies on
                your social media accounts to boost your morale and inspire the
                women in your circle.
              </p>
              <p className="text-sm sm:text-base mb-4 text-justify">
                No matter where you are in your fitness journey, Home Fit Pro is
                dedicated to empowering you to become stronger, more confident,
                and the best version of yourself.
              </p>
              <p className="text-sm sm:text-base mb-4 text-justify">
                Our Cardio app for women combines cardio, strength training,
                stretches, and more, all in one place. With the Women's Home
                Workout App, you have your trainer at your fingertips to help
                you on your Weight Loss journey, right in the comfort of your
                Home Gym.
              </p>
            </div>
            <div className="mt-0">
              <p className="text-sm sm:text-base mb-4 text-justify">
                <b>HOME FIT PRO APP FEATURES:</b>
              </p>
              <ul className="list-disc pl-6 text-sm sm:text-base mb-4 text-justify">
                <li>
                  <b >
                    Workout & Fitness Planning:
                  </b>
                  <p className="text-justify">
                    Over 150+ workouts custom for your fitness level: Beginner,
                    Intermediate or Advanced
                  </p>
                  <p className="text-justify">
                    Choose from 5 programs: Full Body, Upper Body, Lower Body,
                    Squat Challenge, or Core Challenge
                  </p>
                </li>
                <li>
                  <b className="">
                    Fitness Motivation:
                  </b>
                  <p className="text-justify">
                    Track your body transformation
                  </p>
                  <p className="text-justify">
                    Track and log your weight with the weight tracker
                  </p>
                  <p className="text-justify">
                    Compare side-by-side photos of yourself
                  </p>
                </li>
                <li>
                  <b className="">
                    Health Data:
                  </b>
                  <p className="text-justify">
                    Monitor Calories Burnt, Steps Count, and Heart Rates
                  </p>
                </li>
                <li>
                  <b className="">
                    Reminders:
                  </b>
                  <p className="text-justify">
                    Water Reminder
                  </p>
                  <p className="text-justify">
                    Workout Reminder
                  </p>
                  <p className="text-justify">
                    Medicine Reminder
                  </p>
                </li>
                <li>
                  <b className="">
                    Nutrition Education & Recipes:
                  </b>
                  <p className="text-justify">
                    Coming Soon in the next version!
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
